import { styled } from "styled-components";
const ToolbarSeparator = styled("div")(({ theme }) => ({
  alignSelf: "stretch",
  backgroundColor: theme.borderColor,
  backgroundClip: "content-box",
  boxSizing: "content-box",
  flex: "0 0 auto",
  padding: "0 12px",
  width: 1
}));
export {
  ToolbarSeparator
};
